import { type JSX } from "react";

import { useDynamicCallbackIntent } from "@/call-controls/hooks/useDynamicCallbackIntent";

import { DynamicSessionSummary } from "./DynamicSessionSummary";
import { SessionSummary } from "./SessionSummary";
import { useSessionSummaryViewModel } from "./useSessionSummaryViewModel";

/**
 * Shared wrap-up behavior for both summary layouts. Renders the dynamic callback summary when
 * `EWP-dynamicCallbackSessionSummaryEnabled` is on and the intent is supported, and the standard summary otherwise.
 */
export function SessionSummaryContainer(): JSX.Element {
    const viewProps = useSessionSummaryViewModel();
    const { isDynamicCallbackActive } = useDynamicCallbackIntent("summary");

    if (isDynamicCallbackActive) {
        return <DynamicSessionSummary {...viewProps} />;
    }

    return <SessionSummary {...viewProps} />;
}
